import { Crown, Infinity } from 'lucide-react';
import { cn } from '@/lib/utils';

interface PremiumBadgeProps {
  isFoundingMember?: boolean;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
  className?: string;
}

export const PremiumBadge = ({ 
  isFoundingMember = false, 
  size = 'sm',
  showLabel = false,
  className 
}: PremiumBadgeProps) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  };

  const iconSizes = {
    sm: 'w-2.5 h-2.5',
    md: 'w-3 h-3',
    lg: 'w-3.5 h-3.5',
  };

  const textSizes = {
    sm: 'text-[10px]',
    md: 'text-xs',
    lg: 'text-sm',
  };

  if (isFoundingMember) {
    return (
      <div className={cn(
        'inline-flex items-center gap-1',
        className
      )}>
        <div className={cn(
          'rounded-full bg-gradient-to-br from-amber-400 to-yellow-500 flex items-center justify-center flex-shrink-0',
          sizeClasses[size]
        )}>
          <Infinity className={cn('text-white', iconSizes[size])} />
        </div>
        {showLabel && (
          <span className={cn(
            'font-medium text-amber-600 dark:text-amber-400',
            textSizes[size]
          )}>
            Founding
          </span>
        )}
      </div>
    );
  }

  return (
    <div className={cn(
      'inline-flex items-center gap-1',
      className
    )}>
      <div className={cn(
        'rounded-full bg-gradient-to-br from-primary to-cowgirl-pink flex items-center justify-center flex-shrink-0',
        sizeClasses[size]
      )}>
        <Crown className={cn('text-white', iconSizes[size])} />
      </div>
      {showLabel && (
        <span className={cn(
          'font-medium text-primary',
          textSizes[size]
        )}>
          Premium
        </span>
      )}
    </div>
  );
};
